<template>
  <div>
    <CCard class="col-lg-6 col-sm-12">
      <CCardHeader>
        User Info
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CInput
              prepend="Username"
              type="text"
              :value.sync="username"
            >
            </CInput>
          </CCol>
          <CCol sm="12">
            <CInput
              prepend="Mail"
              type="text"
              :value.sync="mail"
            >
            </CInput>
          </CCol>
          <CCol sm="12">
            <CInput
              placeholder="If you don't want to change,leave it blank"
              prepend="Password"
              type="password"
              :value.sync="password"
            >
            </CInput>
          </CCol>
          <CCol sm="12">
            <CInput
              placeholder="If you don't want to change,leave it blank"
              prepend="Password Verify"
              type="password"
              :value.sync="repassword"
            >
            </CInput>
          </CCol>
          <CCol sm="12">
            <CButton
              color="primary"
              square
              @click="changeInfo"
            >
              Submit
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard class="col-lg-6 col-sm-12">
      <CCardHeader>
        API Token
      </CCardHeader>
      <CCardBody>
        <p class="text-muted">Token is used for API authentication (e.g. DDNS callback). Keep it safe.</p>
        <CRow>
          <CCol sm="12">
            <CInput
              id="apiToken"
              prepend="Token"
              :value="token"
              readonly
            >
              <template #append>
                <CButton
                  color="info"
                  square
                  @click="copyToken"
                >
                  Copy
                </CButton>
              </template>
            </CInput>
          </CCol>
          <CCol sm="12" class="mt-2">
            <CButton
              color="warning"
              square
              @click="regenerateToken"
            >
              Regenerate Token
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CToaster :autohide="3000">
      <template v-for="toast in fixedToasts">
        <CToast
          :key="'toast' + toast"
          :show="true"
          :color="alertLevel"
          header="Alert"
        >
          {{ returnMsg }}
        </CToast>
      </template>
    </CToaster>
    <CModal
      title="Request Message"
      color="primary"
      :show.sync="requestMsgModal"
    >
      {{ requestMsg }}
      <template #footer>
        <CButton @click="requestMsgModal=false" color="primary">Close</CButton>
      </template>
    </CModal>
    <CModal
      title="Regenerate Token"
      color="warning"
      :show.sync="regenerateConfirmModal"
    >
      <p>Are you sure you want to regenerate your API token?</p>
      <p class="text-danger">The current token will be invalidated immediately. Any services using this token will stop working.</p>
      <template #footer>
        <CButtonGroup>
          <CButton color="warning" square @click="doRegenerateToken">Confirm</CButton>
          <CButton color="secondary" square @click="regenerateConfirmModal=false">Cancel</CButton>
        </CButtonGroup>
      </template>
    </CModal>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard';

export default {
  name: "Info",
  data() {

    return {
      fixedToasts: 0,
      returnMsg: "",
      alertLevel: "success",
      requestMsgModal: false,
      regenerateConfirmModal: false,
      requestMsg: null,
      username: null,
      mail: null,
      password: null,
      repassword: null,
      token: null
    };
  },
  mounted: function() {
    this.onLoadPage();
  },
  methods: {
    onLoadPage: function() {
      this.$axios.get("user/info", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.username = response.data.username;
            this.mail = response.data.mail;
            this.token = response.data.token;
          }
        });
      this.$axios.get("user/info/token", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.token = response.data.token;
          }
        });
    },
    changeInfo: function() {
      this.$axios.post("user/info", {
        username: this.username,
        mail: this.mail,
        password: this.password,
        repassword: this.repassword
      })
        .then((response) => {
          this.requestMsg = response.data.msg;
          this.requestMsgModal = true;
        });
    },
    copyToken: function() {
      let clipboard = new ClipboardJS("#apiToken .btn-info", {
        text: () => this.token
      });
      clipboard.on("success", () => {
        this.alertLevel = "success";
        this.returnMsg = "Token copied to clipboard";
        this.fixedToasts++;
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        clipboard.destroy();
      });
    },
    regenerateToken: function() {
      this.regenerateConfirmModal = true;
    },
    doRegenerateToken: function() {
      this.regenerateConfirmModal = false;
      this.$axios.post("user/info/token/regenerate", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.token = response.data.token;
            this.alertLevel = "success";
            this.returnMsg = response.data.msg;
            this.fixedToasts++;
          }
        });
    }
  }
};
</script>
